/* Scripts ECHO : envoi par e-mail des configurateurs + parcours ensemble / maillot. */

/* ===== 1) Envoi des configurateurs par e-mail ===== */
(function () {
  if (!window.fetch || window.__echoSendMail) return;
  window.__echoSendMail = true;
  var realFetch = window.fetch;

  function isContactPost(input, init) {
    if (!init || String(init.method).toUpperCase() !== 'POST') return false;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    try {
      var p = new URL(url, location.href).pathname;
      return p.slice(-8) === '/contact' || p.slice(-9) === '/contact/';
    } catch (e) { return false; }
  }

  function field(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value : '';
  }

  window.fetch = function (input, init) {
    if (!isContactPost(input, init)) return realFetch.apply(this, arguments);
    var form = document.getElementById('echo-contact-form');
    var msg = document.getElementById('csvmsg');
    var root = document.querySelector('.echo-cfg');
    if (!form) return realFetch.apply(this, arguments);

    var to = (root && root.getAttribute('data-email')) || 'gayaecho@gmail.com';
    var name = field(form, 'contact[name]');
    var lines = String(field(form, 'contact[body]')).split('\n');
    var li = -1;
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].indexOf('Ouvrir le design') === 0) li = i;
    }
    if (li > -1) {
      var link = lines.splice(li, 1)[0];
      lines.splice(1, 0, link);
    }
    var body = lines.join('\n').slice(0, 3500);
    var subject = 'Design maillot ECHO' + (name ? ' – ' + name : '');

    location.href = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);

    setTimeout(function () {
      if (msg) msg.textContent = 'Ton application mail s’ouvre avec le message prêt : appuie sur Envoyer. Si rien ne s’ouvre, écris à ' + to + '.';
    }, 60);

    return Promise.resolve({ ok: true, status: 200, url: location.origin + '/contact?contact_posted=true' });
  };
})();

/* ===== 2) Parcours « ensemble » / « maillot » du configurateur perso =====
   - Sur les pages produit, les boutons vers /pages/perso reçoivent ?type=ensemble ou ?type=maillot.
   - Sur /pages/perso?type=ensemble : le short est ajouté automatiquement (case masquée).
   - Sur /pages/perso?type=maillot : maillot seul, sans option short.
   - Sans paramètre : comportement d’origine (short en option). */
(function () {
  function tagLinks() {
    var main = document.querySelector('main');
    var t = (main && main.getAttribute('data-template')) || '';
    if (t.indexOf('product.') !== 0) return;
    var type = t.indexOf('perso2') > -1 ? 'maillot' : (t.indexOf('perso') > -1 ? 'ensemble' : '');
    if (!type) return;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var u;
      try { u = new URL(links[i].getAttribute('href'), location.origin); } catch (e) { continue; }
      var p = u.pathname;
      if (p.slice(-1) === '/') p = p.slice(0, -1);
      if (p.slice(-12) === '/pages/perso' && !u.search) links[i].setAttribute('href', p + '?type=' + type);
    }
  }

  function applyType() {
    var m = /[?&]type=(ensemble|maillot)/.exec(location.search);
    if (!m) return;
    var want = m[1] === 'ensemble';
    var tries = 0;
    (function go() {
      var root = document.querySelector('.echo-cfg');
      var cb = document.getElementById('wantShort');
      if (!root || !cb) { if (++tries < 20) setTimeout(go, 150); return; }
      if (cb.checked !== want) {
        cb.checked = want;
        cb.dispatchEvent(new Event('change'));
      }
      var label = cb.closest('label');
      if (label) label.hidden = true;
      var st = document.createElement('style');
      st.textContent = '.echo-cfg #price .hint{display:none}';
      root.appendChild(st);
      var h1 = root.querySelector('h1');
      if (h1) h1.textContent = want ? 'Crée ton ensemble ECHO' : 'Crée ton maillot ECHO';
      var boxes = root.querySelectorAll('.box');
      for (var i = 0; i < boxes.length; i++) {
        var h2 = boxes[i].querySelector('h2');
        if (h2 && h2.textContent === 'Short du maillot') {
          if (want) {
            h2.textContent = 'Short de l’ensemble';
            var hint = boxes[i].querySelector('.hint');
            if (hint) hint.textContent = 'Règle ici les couleurs du short, inclus dans ton ensemble.';
          } else {
            boxes[i].hidden = true;
          }
        }
      }
    })();
  }

  function init() { tagLinks(); applyType(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
